namespace('compass.map');


compass.requireLib('compass.hotel.HotelFilter');

compass.map.MapboxWidget = compass.defineWidget(function(options) {
	var me = this;
	var $j = jQuery;
	var _d = jQuery.dom.getContext(this);
	var _settings = options;
	var _WUID = _settings.WUID;
	
	// no need for redraw, we're manipulating classes in first two arg callbacks
	var _filter = new compass.hotel.HotelFilter(_setMarkerFiltered, _setMarkerUnfiltered, undefined, _redraw);
	var _hotels = JSON.parse(JSON.stringify(_settings.hotels)).map(hotel => {
		// Treat GDS hotels with no avail as sold out when rendering
		if (hotel.avail.status === 'GDS' && hotel.avail.lowestAvgRateNumeric === -1) {
			hotel.avail.status = "SOLDOUT";
		}
		return hotel;
	});
	var _currFilter = {};
	var currentMapboxStyle = _settings.mapbox.streetsStyleUrl;
	var customLoaded = false; //used to ensure we only attempt to replace streetsStyleUrl one time at most
	var styleUrls = {
		streetsStyleUrl: _settings.mapbox.streetsStyleUrl,
		satelliteStyleUrl: _settings.mapbox.satelliteStyleUrl
	};
	
	this.hotelMarkerPairs = []; // array of {hotel: hotelObj, marker: mapboxgl.Marker}
	this.siteMarkerPairs = []; // array of {site: siteObj, marker: mapboxgl.Marker}
	this.selectedHotel = null;
	this.activeStaticHotel = null; // Hotel that is "locked" active after View Route is clicked

	this.render = function (widgetElem) {
		this.setData(_hotels);
		
		if (me.map) {
			me.map.remove();
			me.map = null;
		}
		
		// Remove existing mapMount div if it exists to prevent duplication
		widgetElem.find('#mapMount').remove();
		widgetElem.append(_d.div({id:'mapMount'}));
		
		if(widgetElem.is(':visible')) {
			me.draw();
		}
	};
	this.setData = function(hotels) {
		_hotels = hotels;
		_filter.setData(hotels);
	};
	
	this.updateFilter = function(filterObj) {
		_currFilter = (filterObj || _currFilter);
		_filter.updateFilter(_currFilter);
	};
	
	this.destroy = function() {
		if (me._clearRoute) {
			me._clearRoute();
		}
		
		if (me.map) {
			me.map.remove();
			me.map = null;
		}
		
		me.hotelMarkerPairs = [];
		me.siteMarkerPairs = [];
		me.selectedHotel = null;
		me.currentRoute = null;
		
		me.getWidgetElem().find('#mapMount').remove();
	};

	this.resetToInitialState = function() {
		me.selectedHotel = null;
		me.activeStaticHotel = null;
		
		var routeLegend = me.find('.routeLegendWrapper');
		if (routeLegend.length > 0) {
			routeLegend.hide();
		}
		
		if (me.map && me._clearRoute) {
			me._clearRoute();
		}
		
		me.find('.mapboxgl-popup').remove();
	};

	// Bind to route response events from hotels.js
	this.bind('MapboxWidget.routeResponse', function(evt, data, requestData) {
		me._handleRouteResponse(data, requestData);
	});
	
	this.bind('MapboxWidget.routeError', function(evt, xhr, status, error, requestData) {
		me._handleRouteError(xhr, status, error, requestData);
	});

	// draw is also bound to mapViewClicked
	this.draw = function(options) {
		compass.loading.start();
		// fetchmapbox sets this.draw as a callback for mapbox script el onload, so it will
		// call draw again when the mapbox library becomes available
		if (typeof mapboxgl === 'undefined') return this.fetchMapbox();
		
		if (me.map) {
			me.map.remove();
			me.map = null;
		}
		
		me.getWidgetElem().show(); // warning: has to come before the updateFilter call

		// Ensure #mapMount exists (render() may not have called draw() if widget wasn't visible)
		if (me.getWidgetElem().find('#mapMount').length === 0) {
			me.getWidgetElem().append(_d.div({id:'mapMount'}));
		}

		if (_settings.meetingInfo.enableRouteViewMode) {
			me.getWidgetElem().addClass('route-view-enabled');
		}
		
		var siteLngLat = [ _settings.meetingInfo.site.longitude, _settings.meetingInfo.site.latitude];
		me.boundingBox = new mapboxgl.LngLatBounds(
			[siteLngLat[0], siteLngLat[1]], 
			[siteLngLat[0], siteLngLat[1]]
		);
		
		mapboxgl.accessToken = 'pk.eyJ1Ijoib25wZWFrIiwiYSI6ImNqYTRjMGl0MzE5OHEyd2xmNGo2OTM1aXEifQ.1qKlI1sL9ZgN3F8QP7TOtg';

		var mapContainer = me.getWidgetElem().find('#mapMount').get(0);

		me.map = new mapboxgl.Map({
			container: mapContainer,
			/* allow for meeting rule for mapbox studio styles */
			style: _settings.meetingInfo.mapboxStyleUrl || currentMapboxStyle,
			center: siteLngLat,
			zoom: _settings.mapbox.zoom,
			trackResize: true
		});
		// if custom style exists and succeeds, replace street style URL with custom style URL (for toggle)
		if (_settings.meetingInfo.mapboxStyleUrl) {
			me.map.on('style.load', function() {
				if (!customLoaded) {
					customLoaded = true;
					styleUrls.streetsStyleUrl = _settings.meetingInfo.mapboxStyleUrl;
				}
			});
		}
		// switch back to default style if custom style fails to load
		me.map.once('error', function(mapError) {
			customLoaded = true;
			me.map.setStyle( styleUrls.streetsStyleUrl );
			if ( window.mapboxErrorFired ) return;
			window.mapboxErrorFired = true;
		});
		me.map.dragRotate.disable();
		
		me.map.touchZoomRotate.disableRotation();

		if (_settings.useSiteMarker) {
			me.siteMarkerPair = _drawSiteMarker(_settings.meetingInfo.site);
			me.altSiteMarkerPairs = _.compact(_.map(_settings.meetingInfo.alternateSites, _drawSiteMarker));
		}

		me.hotelMarkerPairs = _.compact(_.map(_hotels, _drawHotelMarker));
		me.map.fitBounds(me.boundingBox, {padding: _settings.mapbox.padding});
		
		_drawMapControls();
		me.updateFilter();
		me.find('.mapTab').toggleClass('disabled', false).toggleClass("mapLoaded", true);
		compass.loading.stop();
	};
	
	function _redraw(hotels) {
		_hotels = hotels;
		_filter.setData(hotels);
		
		if( me.getWidgetElem().is(':visible') ) {

			me.hotelMarkerPairs = _.compact(_.map(_hotels, _drawHotelMarker));
			me.map.fitBounds(me.boundingBox, {padding: _settings.mapbox.padding});
			
			
			_.forEach(hotels, function(hotel) {
				var hotelMarkerPair = _.find(me.hotelMarkerPairs, function(hotelMarkerPair) {
					return hotelMarkerPair.hotel.hotelId === hotel.hotelId;
				});
				
				if ( hotelMarkerPair == null ){ 
					return null;
				}
				
				hotelMarkerPair.hotel = hotel;

				var soldOut = !(hotel.avail.status === 'NORMAL' || hotel.avail.status === 'GDS');
				if(soldOut) {
					_setMarkerFiltered(hotel.hotelId)();
				} else {
					_setMarkerUnfiltered(hotel.hotelId)();
				}
			});
		}
	}

	function _drawSiteMarker(site) {
		var lnglat = new mapboxgl.LngLat(site.longitude, site.latitude);
		var siteIcon = document.createElement('img');
		siteIcon.src = compass.staticPrefix + '/resources/img/compass/map/conference.png';
		siteIcon.className = 'siteMarker';
		
		me.boundingBox.extend(lnglat);
		var siteMarker = new mapboxgl.Marker(siteIcon, {offset: [0, -19]})
			.setLngLat([site.longitude, site.latitude])
			.setPopup(_createSitePopup(site))
			.addTo(me.map);
		
		// Add hover behavior for site marker only if route view mode is enabled
		if (_settings.meetingInfo.enableRouteViewMode) {
			var sitePopupTimeout;
			var sitePopup = siteMarker.getPopup();
			
			siteIcon.addEventListener('mouseenter', function() {
				clearTimeout(sitePopupTimeout);
				sitePopup.addTo(me.map);
			});
			
			siteIcon.addEventListener('mouseleave', function() {
				sitePopupTimeout = setTimeout(function() {
					sitePopup.remove();
				}, 200);
			});
			
			sitePopup.on('open', function() {
				var popupElement = document.querySelector('.mapboxgl-popup');
				if (popupElement) {
					popupElement.addEventListener('mouseenter', function() {
						clearTimeout(sitePopupTimeout);
					});
					
					popupElement.addEventListener('mouseleave', function() {
						sitePopupTimeout = setTimeout(function() {
							sitePopup.remove();
						}, 200);
					});
				}
			});
		}
		
		return {site: site, marker: siteMarker};
	}
	
	function _createSitePopup(site) {
		var siteInfoDOM = _d.div({ className : 'siteNameWrapper' },
			_d.p({ className : 'siteName' }, site.name )
		).get(0);
		// Only disable closeOnClick if route view mode is enabled
		var popupOptions = _settings.meetingInfo.enableRouteViewMode ? {closeOnClick: false} : {};
		var popup = new mapboxgl.Popup(popupOptions).setDOMContent(siteInfoDOM);
		
		popup.on('open', function() {
			// Query entire page, since we are modifying hotel popups outside of MapboxWidget container
			var isMapExpanded = $j('.mapOrGridWrapper').hasClass('full-map-view');
			if (isMapExpanded) {
				compass.GA.trackEvent('Split View', 'Map Interaction', 'Meeting Site Marker Click - Expanded View');
			} else {
				compass.GA.trackEvent('Split View', 'Map Interaction', 'Meeting Site Marker Click - Split View');
			}
		});
		
		return popup;
	}

	function _drawHotelMarker(hotel) {
		var lnglat = new mapboxgl.LngLat(hotel.longitude, hotel.latitude);
		me.boundingBox.extend(lnglat);
		
		var hotelMarkerDOM = _d.i({ className : 'fa-solid fa-location-dot hotelMarker' }).get(0);
		
		var soldOut = !(hotel.avail.status === 'NORMAL' || hotel.avail.status === 'GDS');
		if(soldOut) {
			hotelMarkerDOM.className += ' filteredMarker';
		}
		
		// Add keyboard event handler to prevent Enter key when static hotel is active
		hotelMarkerDOM.addEventListener('keydown', function(e) {
			if (e.key === 'Enter' || e.key === ' ') {
				// Don't allow keyboard activation when there's an active static hotel and this isn't it
				if (me.activeStaticHotel && me.activeStaticHotel.hotelId !== hotel.hotelId) {
					e.preventDefault();
					e.stopPropagation();
					return;
				}
				
				// Don't allow keyboard activation on filtered (sold out) markers
				if ($j(hotelMarkerDOM).hasClass('filteredMarker')) {
					e.preventDefault();
					e.stopPropagation();
					return;
				}
			}
		});
		
		var hotelMarker = new mapboxgl.Marker(hotelMarkerDOM, {offset: [0, -19]})
			.setLngLat(lnglat)
			.setPopup(_createHotelPopup(hotel))
			.addTo(me.map);
			
		// Add route-specific hover behavior only if route view mode is enabled
		if (_settings.meetingInfo.enableRouteViewMode) {
			hotelMarkerDOM.addEventListener('click', function(e) {
				e.stopPropagation();

				if ($j(hotelMarkerDOM).hasClass('filteredMarker')) {
					e.preventDefault();
					return;
				}
				
				// Don't allow clicking other hotel pins when there's an active static hotel
				if (me.activeStaticHotel && me.activeStaticHotel.hotelId !== hotel.hotelId) {
					return;
				}
			});
			
			var popupTimeout;
			var popup = hotelMarker.getPopup();
			
			hotelMarkerDOM.addEventListener('mouseenter', function() {
				if ($j(hotelMarkerDOM).hasClass('filteredMarker')) {
					return;
				}
				
				// Don't show hover popup if there's an active static hotel and this isn't it
				if (me.activeStaticHotel && me.activeStaticHotel.hotelId !== hotel.hotelId) {
					return;
				}
				clearTimeout(popupTimeout);
				popup.addTo(me.map);
			});
			
			hotelMarkerDOM.addEventListener('mouseleave', function() {
				// Don't hide popup if this hotel is the active static one
				if (me.activeStaticHotel && me.activeStaticHotel.hotelId === hotel.hotelId) {
					return;
				}
				popupTimeout = setTimeout(function() {
					popup.remove();
				}, 200);
			});
			
			popup.on('open', function() {
				me.selectedHotel = hotel;

				// Query entire page, since we are modifying hotel popups outside of MapboxWidget container
				var isMapExpanded = $j('.mapOrGridWrapper').hasClass('full-map-view');
				var popupCard = $j(popup.getElement()).find('.hotelCard.mapboxCompact');
				if (isMapExpanded) {
					compass.GA.trackEvent('Split View', 'Map Interaction', 'Hotel Marker Click - Expanded View');
				} else {
					compass.GA.trackEvent('Split View', 'Map Interaction', 'Hotel Marker Click - Split View');
				}

				if (popupCard.length > 0) {
					if (isMapExpanded) {
						popupCard.toggleClass('expanded', true);
					} else {
						popupCard.toggleClass('expanded', false);
					}
				}

				var popupElement = popup.getElement();
				if (popupElement) {
					popupElement.addEventListener('mouseenter', function() {
						clearTimeout(popupTimeout);
					});
					
					popupElement.addEventListener('mouseleave', function() {
						// Don't hide popup if this hotel is the active static one
						if (me.activeStaticHotel && me.activeStaticHotel.hotelId === hotel.hotelId) {
							return;
						}
						popupTimeout = setTimeout(function() {
							popup.remove();
						}, 200);
					});
				}
			});
			
			popup.on('close', function() {
				// Don't clear selectedHotel if this hotel is the active static one
				if (me.activeStaticHotel && me.activeStaticHotel.hotelId === hotel.hotelId) {
					return;
				}
				
				// Only clear selectedHotel if the route legend is not visible
				// This prevents losing the selected hotel when hovering away from popup
				// but the route legend is still being used
				var routeLegend = me.find('.routeLegendWrapper');
				if (!routeLegend.is(':visible')) {
					me.selectedHotel = null;
				}
				
				me.find('.viewRouteButton.showing-route').toggleClass('showing-route', false);
			});
		}
		
		return {hotel: hotel, marker: hotelMarker};
	}
	
	function _createHotelPopup(hotel) {
		var popupOptions = _settings.meetingInfo.enableRouteViewMode ? {closeOnClick: false} : {};
		
		if(_settings.popupUsesHotelCard) {
			// Only use mapboxHotelCardWrapper class if route view mode is enabled, otherwise use default
			var wrapperClass = _settings.meetingInfo.enableRouteViewMode ? 'mapboxHotelCardWrapper' : '';
			var wrapper = _d.div({ className: wrapperClass });
			var hotelPopup = new compass.hotel.HotelCardWidget(wrapper, {
				meetingInfo : _settings.meetingInfo,
				WUID : 'MapboxWidget_HotelCardWidget_' + _WUID,
				hotel : hotel,
				displayHotelStars: _settings.displayHotelStars,
				displayPriceSavings: _settings.displayPriceSavings,
				hideDistance: _settings.hideDistance,
				hideNumberOfRoomsAvailable : _settings.hideNumberOfRoomsAvailable,
				compactLayout: _settings.meetingInfo.enableRouteViewMode || false
			});
			
			// Add route event handlers only if route view mode is enabled
			if (_settings.meetingInfo.enableRouteViewMode) {
				hotelPopup.bind('HotelCard.viewRoute', function(e, data) {
					me.selectedHotel = data.hotel;
					me.activeStaticHotel = data.hotel;

					me._clearRoute();

					me.find('.routeViewButton').toggleClass('active', false);
					me.find('.routeViewButton[data-mode="none"]').toggleClass('active', true);

					if (me.routeLegend && me.routeLegend.wrapper) {
						me.routeLegend.wrapper.show();
					}
					
					var routeLegend = me.find('.routeLegendWrapper');
					if (routeLegend.length > 0) {
						routeLegend.show();
					}
					
					me._updateStartEndSection(data.hotel);
				});
				
				hotelPopup.bind('HotelCard.hideRoute', function(e, data) {
					me._clearRoute();
					
					if (me.routeLegend && me.routeLegend.wrapper) {
						me.routeLegend.wrapper.hide();
					}
					
					var routeLegend = me.find('.routeLegendWrapper');
					if (routeLegend.length > 0) {
						routeLegend.hide();
					}
					
					me.selectedHotel = null;
					me.activeStaticHotel = null;
					
					var popup = data.hotel.popup || me.hotelMarkerPairs.find(function(pair) {
						return pair.hotel.hotelId === data.hotel.hotelId;
					});
					if (popup && popup.marker && popup.marker.getPopup()) {
						popup.marker.getPopup().remove();
					}
				});
			}
			
			return new mapboxgl.Popup(popupOptions).setDOMContent(wrapper.get(0));
			
		} else {
			var hotelPopupDOM = _d.div({ className : 'siteNameWrapper' },
				_d.p({ className : 'siteName' }, hotel.name )
			).get(0);
			return new mapboxgl.Popup(popupOptions).setDOMContent(hotelPopupDOM);
		}
	}
	
	function _drawMapControls() {
		var streetsStyleToggle = _d.span({className:'mapStyleToggle active', id:'streets'}, 'Streets')
			.click(handleMapStyleToggleClick);
		var satelliteStyleToggle = _d.span({className:'mapStyleToggle', id:'satellite'}, 'Satellite')
			.click(handleMapStyleToggleClick);
		
		me.getWidgetElem().append(
			_d.div({className: 'mapStyleToggleWrapper'}, 
				[
					streetsStyleToggle, 
					satelliteStyleToggle
				])
			);
		
		var zoomInButton = _d.div({className:'zoomButton', id:'zoomIn'}, '+')
			.click(function(e) {me.map.zoomIn();});
		var zoomOutButton = _d.div({className:'zoomButton', id:'zoomOut'}, '-')
			.click(function(e) {me.map.zoomOut();});
		
		me.getWidgetElem().append(
			_d.div({className: 'zoomButtonWrapper'},
				[
					zoomInButton,
					zoomOutButton
				])
		);

		if (_settings.meetingInfo.enableRouteViewMode) {
			_drawRouteLegend();
		}
	}
	
	function handleMapStyleToggleClick(e) {
		var mapboxStyleToggle = $j(this);
		var mapboxStyleVarName = mapboxStyleToggle.attr('id') + 'StyleUrl';

		if(currentMapboxStyle !== styleUrls[mapboxStyleVarName]) {
			// Store current route data before changing style
			var savedRoute = null;
			if (me.currentRoute) {
				savedRoute = {
					route: me.currentRoute,
					routeData: null
				};
				
				// Get the route geometry from the current source
				['walking', 'driving'].forEach(function(mode) {
					var sourceId = mode + '-route';
					var source = me.map.getSource(sourceId);
					if (source && source._data) {
						savedRoute.routeData = source._data;
						savedRoute.mode = mode;
					}
				});
			}
			
			me.map.setStyle(styleUrls[mapboxStyleVarName]);
			me.find('.mapStyleToggle.active').toggleClass('active', false);
			mapboxStyleToggle.toggleClass('active', true);
			currentMapboxStyle = styleUrls[mapboxStyleVarName];
			
			// Re-add route after style loads
			if (savedRoute) {
				me.map.once('style.load', function() {
					if (savedRoute.routeData && savedRoute.mode) {
						var routeColor = savedRoute.mode === 'walking' ? '#3b82f6' : '#dc2626';
						var sourceId = savedRoute.mode + '-route';
						var layerId = savedRoute.mode + '-route-layer';
						
						me.map.addSource(sourceId, {
							type: 'geojson',
							data: savedRoute.routeData
						});
						
						me.map.addLayer({
							id: layerId,
							type: 'line',
							source: sourceId,
							layout: {
								'line-join': 'round',
								'line-cap': 'round'
							},
							paint: {
								'line-color': routeColor,
								'line-width': savedRoute.mode === 'walking' ? 4 : 6,
								'line-opacity': 0.8,
								'line-dasharray': savedRoute.mode === 'walking' ? [2, 2] : [1, 0]
							}
						});
						
						// Restore the currentRoute object
						me.currentRoute = savedRoute.route;
					}
				});
			}
		}
	}
	
	function _drawRouteLegend() {
		me.find('.routeLegendWrapper').remove();
		
		var legendWrapper = _d.div({className: 'routeLegendWrapper', style: 'display: none;'});
		
		var legendHeader = _d.div({className: 'routeLegendHeader'}, 'Route Details');
		
		var routeInfoSection = _d.div({className: 'routeInfoSection'});
		
		var errorMessage = _d.div({className: 'route-error-message', style: 'display: none;'}, [
			_d.i({className: 'fa-regular fa-circle-exclamation'}),
			_d.span({}, 'Route details are currently unavailable. Please try again or select a different route type.')
		]);
		
		var noneButton = _d.div({className: 'routeViewButton active', 'data-mode': 'none'}, 'None').click(_handleRouteViewClick);
		var walkingButton = _d.div({className: 'routeViewButton', 'data-mode': 'walking'}, 'Walking').click(_handleRouteViewClick);
		var drivingButton = _d.div({className: 'routeViewButton', 'data-mode': 'driving'}, 'Driving').click(_handleRouteViewClick);
		
		var buttonWrapper = _d.div({className: 'routeViewButtons'}, [
			noneButton, walkingButton, drivingButton
		]);
		
		legendWrapper.append(legendHeader, routeInfoSection, errorMessage, buttonWrapper);
		
		me.getWidgetElem().append(legendWrapper);
		
		me.routeLegend = {
			wrapper: legendWrapper,
			infoSection: routeInfoSection,
			errorMessage: errorMessage,
			buttons: {
				none: noneButton,
				walking: walkingButton,
				driving: drivingButton
			}
		};
	}
	
	this._updateStartEndSection = function(hotel) {
		if (!me.routeLegend || !me.routeLegend.infoSection) return;
		
		me.routeLegend.infoSection.empty();
		
		var startIcon = _d.div({className: 'legendIcon start redCircle'});
		var startLabel = _d.div({className: 'legendLabel'}, [
			_d.div({className: 'legendTitle'}, 'Start'),
			_d.div({className: 'legendLocation'}, hotel.name)
		]);
		
		var meetingLocation = _settings.meetingInfo.venueName || _settings.meetingInfo.site.name || 'Meeting Location';
		var endIcon = _d.img({className: 'legendIcon end buildingIcon', src: compass.staticPrefix + '/resources/img/compass/map/conference.png', alt: 'Meeting Location'});
		var endLabel = _d.div({className: 'legendLabel'}, [
			_d.div({className: 'legendTitle'}, 'End'),
			_d.div({className: 'legendLocation'}, meetingLocation)
		]);
		
		var pathDots = [];
		for (var i = 0; i < 7; i++) {
			pathDots.push(_d.div({className: 'pathDot'}));
		}
		var visualPathDots = _d.div({className: 'visualPathDots'}, pathDots);
		
		me.routeLegend.infoSection.append([
			_d.div({className: 'routePoint'}, [startIcon, startLabel]),
			visualPathDots,
			_d.div({className: 'routePoint'}, [endIcon, endLabel])
		]);
		
		me.routeLegend.infoSection.show();
	};
	
	function _handleRouteViewClick() {
		var button = $j(this);
		var mode = button.data('mode');
		
		var modeLabel = mode.charAt(0).toUpperCase() + mode.slice(1);
		compass.GA.trackEvent('Split View', 'Route Legend Toggle', modeLabel);
		
		me.find('.routeViewButton').toggleClass('active', false);
		button.toggleClass('active', true);
		
		if (mode === 'none') {
			me._clearRoute();
			if (me.routeLegend && me.routeLegend.infoSection) {
				me.routeLegend.infoSection.find('.travelModesSection').hide();
			}
		} else if (mode === 'walking' || mode === 'driving') {
			var routeTargetHotel = me.selectedHotel;
			
			if (routeTargetHotel && _settings.meetingInfo && _settings.meetingInfo.site) {
				me._clearRoute();
				
				me._getDirections(routeTargetHotel, _settings.meetingInfo.site, mode);
				
				compass.GA.trackEvent('Split View', 'Route Generated', mode + ' - Hotel ' + routeTargetHotel.hotelId + ' to ' + _settings.meetingInfo.site.name);
			} else {
				compass.GA.trackEvent('Split View', 'Route Error', 'No Hotel Available - ' + mode);
			}
		}
	}
	
	function _updateRouteLegend(hotel, site, route, mode) {
		if (!me.routeLegend || !me.routeLegend.infoSection) return;

		var useKilometers = hotel.distanceUnits === 'Kilometers';

		var distance, distanceUnit;
		if (useKilometers) {
			distance = (route.distance / 1000).toFixed(1);
			distanceUnit = ' km';
		} else {
			distance = (route.distance / 1609.34).toFixed(1);
			distanceUnit = ' mi';
		}
		
		var durationMin = Math.round(route.duration / 60);
		
		me.routeLegend.infoSection.find('.travelModesSection').remove();
		
		var iconClass = mode === 'walking' ? 'fa-solid fa-person-walking walking' : 'fa-solid fa-car driving';
		var modeText = mode.charAt(0).toUpperCase() + mode.slice(1);
		
		var travelMode = _d.div({className: 'travelMode'}, [
			_d.i({className: 'modeIcon ' + iconClass}),
			_d.span({className: 'modeLabel'}, modeText),
			_d.span({className: 'modeDuration'}, durationMin + ' min'),
			_d.span({className: 'modeDistance'}, distance + distanceUnit)
		]);
		
		var travelModesSection = _d.div({className: 'travelModesSection'}, [travelMode]);
		
		me.routeLegend.infoSection.append(travelModesSection);
	}
	
	function _setMarkerFiltered(hotelId) {
		var hotelMarkerPair = _.find(me.hotelMarkerPairs, function(hotelMarkerPair) {
			return hotelMarkerPair.hotel.hotelId === hotelId;
		});
		return function() {
			if(!me.getWidgetElem().is(':visible')) return;

			var markerEl = hotelMarkerPair.marker.getElement();
			$j(markerEl).toggleClass('filteredMarker', true);
			
			var popup = hotelMarkerPair.marker.getPopup();
			if (popup) popup.remove(); // remove from map instance
			hotelMarkerPair.marker.setPopup(null);
		};
	}
	
	function _setMarkerUnfiltered(hotelId) {
		var hotelMarkerPair = _.find(me.hotelMarkerPairs, function(hotelMarkerPair) {
			return hotelMarkerPair.hotel.hotelId === hotelId;
		});
		
		
		return function() {
			if ( hotelMarkerPair == null){ return; }
			
			if(!me.getWidgetElem().is(':visible')) return;
			
			hotelMarkerPair.marker.setPopup(_createHotelPopup(hotelMarkerPair.hotel));
			
			/* avail.status is set after checkin/checkout filter fetches avail data
				if hotel is soldout we shouldn't set unfiltered */
			var soldOut = !(hotelMarkerPair.hotel.avail.status === 'NORMAL' || hotelMarkerPair.hotel.avail.status === 'GDS');
			if(soldOut) return;
			
			var markerEl = hotelMarkerPair.marker.getElement();
			$j(markerEl).toggleClass('filteredMarker', false);
		};
	}
	
	this.fetchMapbox = function() {
		var mapboxCSS = document.createElement('link');
		mapboxCSS.rel = 'stylesheet';
		mapboxCSS.type = 'text/css';
		mapboxCSS.href = 'https://api.tiles.mapbox.com/mapbox-gl-js/v3.2.0/mapbox-gl.css';
		document.getElementById('scriptTags').appendChild(mapboxCSS);
		
		var mapboxScript = document.createElement('script');
		mapboxScript.type = 'text/javascript';
		mapboxScript.src = 'https://api.tiles.mapbox.com/mapbox-gl-js/v3.2.0/mapbox-gl.js';
		// trigger draw on load of script, kind of like a callback for the mapbox fetch
		mapboxScript.onload = this.draw;

		document.getElementById('scriptTags').appendChild(mapboxScript);
	};
	
	// General directions functionality (walking or driving)
	this._getDirections = function(hotel, site, mode) {
		var requestData = {
			hotel_lat: hotel.latitude,
			hotel_lng: hotel.longitude,
			site_lat: site.latitude,
			site_lng: site.longitude,
			mode: mode,
			hotel_id: hotel.hotelId || 'N/A',
			hotel_name: hotel.name || 'N/A',
			site_name: site.name || 'N/A',
			distance: hotel.distance || 'N/A',
			distance_units: hotel.distanceUnits || 'N/A',
			initiated_from: 'map_widget'
		};
		
		// Trigger route request event for hotels.js to handle
		me.trigger('MapboxWidget.routeRequest', requestData);
	};
	
	// Handle route response from hotels.js
	this._handleRouteResponse = function(data, requestData) {
		var mode = requestData.mode;
		if (data.error) {
			compass.GA.trackEvent('Split View', 'Route Error', 'API Error - ' + mode);
			me._showRouteError();
		} else if (data.routes && data.routes.length > 0) {
			// Hide any existing error messages
			if (me.routeLegend && me.routeLegend.errorMessage) {
				me.routeLegend.errorMessage.hide();
			}

			// Find hotel from requestData
			var hotel = _.find(me.hotelMarkerPairs, function(pair) {
				return pair.hotel.latitude == requestData.hotel_lat && 
					   pair.hotel.longitude == requestData.hotel_lng;
			});
			
			var site = _settings.meetingInfo.site;
			if (hotel) {
				me._displayRoute(data.routes[0], hotel.hotel, site, mode);
			}
		} else {
			compass.GA.trackEvent('Split View', 'Route Error', 'No Route Found - ' + mode);
			me._showRouteError();
		}
	};
	
	// Handle route error from hotels.js
	this._handleRouteError = function(xhr, status, error, requestData) {
		var mode = requestData.mode;
		compass.GA.trackEvent('Split View', 'Route Error', 'Network Error - ' + mode);
		me._showRouteError();
	};
	
	this._showRouteError = function() {
		if (me.routeLegend && me.routeLegend.errorMessage) {
			me.routeLegend.errorMessage.css('display', 'flex');
			setTimeout(function() {
				me.routeLegend.errorMessage.fadeOut(500);
			}, 5000);
		}
	};

	this._displayRoute = function(route, hotel, site, mode) {
		this._clearRoute();
		
		var routeColor = mode === 'walking' ? '#3b82f6' : '#dc2626';
		var routeOpacity = 0.8;
		var sourceId = mode + '-route';
		var layerId = mode + '-route-layer';
		
		if (me.map.getSource(sourceId)) {
			me.map.removeSource(sourceId);
		}
		if (me.map.getLayer(layerId)) {
			me.map.removeLayer(layerId);
		}
		
		me.map.addSource(sourceId, {
			type: 'geojson',
			data: {
				type: 'Feature',
				geometry: route.geometry
			}
		});
		
		me.map.addLayer({
			id: layerId,
			type: 'line',
			source: sourceId,
			layout: {
				'line-join': 'round',
				'line-cap': 'round'
			},
			paint: {
				'line-color': routeColor,
				'line-width': mode === 'walking' ? 4 : 6,
				'line-opacity': routeOpacity,
				'line-dasharray': mode === 'walking' ? [2, 2] : [1, 0]
			}
		});
		
		var coordinates = route.geometry.coordinates;
		var bounds = coordinates.reduce(function(bounds, coord) {
			return bounds.extend(coord);
		}, new mapboxgl.LngLatBounds(coordinates[0], coordinates[0]));
		
		me.map.fitBounds(bounds, {
			padding: 50
		});
		
		me.currentRoute = {
			distance: route.distance,
			duration: route.duration,
			hotel: hotel,
			site: site,
			mode: mode
		};
		
		_updateRouteLegend(hotel, _settings.meetingInfo.site, route, mode);
		
		me.find('.routeViewButton').toggleClass('active', false);
		me.find('.routeViewButton[data-mode="' + mode + '"]').toggleClass('active', true);
	};
	
	this._clearRoute = function() {
		['walking', 'driving'].forEach(function(mode) {
			var layerId = mode + '-route-layer';
			var sourceId = mode + '-route';
			
			if (me.map.getLayer(layerId)) {
				me.map.removeLayer(layerId);
			}
			if (me.map.getSource(sourceId)) {
				me.map.removeSource(sourceId);
			}
		});
		
		me.currentRoute = null;
	};
	
}, { // default settings
	'WUID' : 'crap',
	widgetName : 'MapboxWidget', 
	imgPath : 'resources/img',
	useSiteMarker : true,
	displayHotelStars : true,
	popupUsesHotelCard: true,
    hideNumberOfRoomsAvailable : false,
	hotels : [],
	mapbox : {
		streetsStyleUrl: 'mapbox://styles/onpeak/cja4c1bk32gzz2sp94fu4qkyx',
		satelliteStyleUrl: 'mapbox://styles/onpeak/cjalnf1rgcuh82roa8tohipk0',
		zoom: 14,
		padding: 50
	}
}
);